import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ed925c70&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=ed925c70&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed925c70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/daniel/work/jiangxi/fed-sd-visual-web-static/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed925c70')) {
      api.createRecord('ed925c70', component.options)
    } else {
      api.reload('ed925c70', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ed925c70&scoped=true&", function () {
      api.rerender('ed925c70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/digital-carousel/index.vue"
export default component.exports